/**
 * Ensures we only auto-align `rivet_app_version` with `version.json` once per full
 * document load. First fetch after navigation/reload may sync storage; later refetches
 * (polling / focus) must not hide the update banner until the user applies an update.
 */
let didSyncStoredVersionFromManifestThisDocument = false;

export function consumeDocumentLevelManifestVersionSync(): boolean {
  if (didSyncStoredVersionFromManifestThisDocument) return false;
  didSyncStoredVersionFromManifestThisDocument = true;
  return true;
}

export function resetDocumentLevelManifestVersionSyncForTests(): void {
  didSyncStoredVersionFromManifestThisDocument = false;
}
